<template>
  <v-dialog v-model="dialog" content-class="terms-modal">
    <v-card>
      <v-card-title>
        <h2 v-if="messageTitle" class="md-title">
          {{ messageTitle | translate }}
        </h2>
      </v-card-title>
      <TermsDK v-if="getLanguage === 'dk'" />
      <TermsUK v-else />
      <!-- <v-card-actions>
        <v-layout row wrap justify-end>
          <v-flex xs12 text-xs-right class="pr-2">
            <v-btn flat @click="closeDialog" class="def-btn">{{
              "lng_close" | translate
            }}</v-btn>
            <v-btn flat @click="giveAccess" class="def-btn">{{
              "lng_ok" | translate
            }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions> -->
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-btn class="raised-btn" block flat @click="closeDialog">{{
              "lng_button_logout" | translate
            }}</v-btn>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-btn
              class="primary-btn"
              block
              flex
              xs12
              flat
              @click="giveAccess"
              >{{ "lng_accept_text" | translate }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TermsUK from "../terms/terms-uk";
import TermsDK from "../terms/terms-dk";

export default {
  name: "TechAccessDialog",
  components: {
    TermsUK,
    TermsDK
  },
  data() {
    return {
      dialog: false
    };
  },
  props: {
    messageText: {
      type: String,
      default: "lng_smith_warning"
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    giveAccess: {
      type: Function,
      default: undefined
    },
    translate: {
      type: Boolean,
      default: true
    },
    messageTitle: {
      type: String,
      default: ""
    }
  },
  computed: {
    getLanguage() {
      return localStorage.getItem("language");
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    }
  }
};
</script>
<style>
.v-dialog.terms-modal {
  max-width: 80% !important;
  overflow-y: auto;
}
.md-title {
  font-size: 20px;
  letter-spacing: 0.005em;
}
</style>
<style scoped>
.raised-btn {
  background-color: rgb(250, 250, 250);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}
.primary-btn {
  background-color: rgb(84, 110, 122);
  color: #fff !important;
}
.termsUl {
  padding-left: 20px;
}
.termsUl li {
  list-style: decimal;
  padding: 4px 0;
}
.termsUl li ul {
  padding-left: 10px;
}
.termsUl li ul li {
  list-style: none;
}
</style>
